import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import ActionBarItemWrapper from '../../_partials/items/ActionBarItemWrapper';
import { pushAdoptsOrderOriginalDeviationModal } from '../../../Modals/redux/actionCreators';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
}

export const RequestOriginalButton: React.FC<
  React.PropsWithChildren<Props>
> = ({ deviation, className }) => {
  const { t } = useTranslation();
  const dispatchPushAdoptsOrderOriginalDeviationModal = useAction(
    pushAdoptsOrderOriginalDeviationModal
  );

  const handleClick = useCallback(() => {
    dispatchPushAdoptsOrderOriginalDeviationModal(deviation);
  }, [dispatchPushAdoptsOrderOriginalDeviationModal, deviation]);

  return (
    <ActionBarItemWrapper className={className}>
      <BrandedButton variant="originals" size={'medium'} onClick={handleClick}>
        {t('actionbar.requestOriginal')}
      </BrandedButton>
    </ActionBarItemWrapper>
  );
};
RequestOriginalButton.displayName = 'RequestOriginalButton';

export default RequestOriginalButton;
